import { TellentRoute, TellentRouteFactoryFn } from '@tellent/types';

const exactMatch = (location: string, path: string) => location === path;

export const tellentRouteFactory: TellentRouteFactoryFn = (
  id,
  urlStrOrFactory,
  options?,
): TellentRoute => {
  let buildPath;

  if (typeof urlStrOrFactory === 'string') buildPath = () => urlStrOrFactory;

  if (typeof urlStrOrFactory === 'function') buildPath = urlStrOrFactory;

  if (!buildPath) {
    throw new Error(`[Tellent] Invalid route url factory for ${id}`);
  }

  const matchPath = options?.matchPath ?? exactMatch;

  return {
    id,
    buildPath,
    matchPath,
  };
};

export const parametrizedRoutePath =
  <P extends Record<string, string>>(str: string) =>
  (params?: P) =>
    params ? Object.entries(params).reduce((acc, [k, v]) => acc.replace(`:${k}`, v), str) : str;
